import { render, staticRenderFns } from "./CanvasPanel.vue?vue&type=template&id=48f35ba6&scoped=true"
import script from "./CanvasPanel.vue?vue&type=script&lang=js"
export * from "./CanvasPanel.vue?vue&type=script&lang=js"
import style0 from "./CanvasPanel.vue?vue&type=style&index=0&id=48f35ba6&prod&lang=css"
import style1 from "./CanvasPanel.vue?vue&type=style&index=1&id=48f35ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f35ba6",
  null
  
)

export default component.exports